import { Axios } from 'axios';
import { SearchHistory } from '~/types/api/search';
import fclient from './fclient';

const c = fclient('/search');

// TODO from Nikola: accept arrays for multi-value params like "type" and join them into the API's expected format here, instead of every caller pre-joining its own comma-separated string (see integrations/api/transactable-symbol-search.ts).
// This current approach pollutes the callers' implementation with unnecessary knowledge of API call convetions and increases refactor scope for potential API changes.
// The HTTP client should handle API call formatting/serialization specifics, and clearly define the scope of supported parameters, rather than using a umbrella "payload".
export const search = (a: Axios, payload: object) => {
  return c(a).get({ params: payload });
};

export const getSearchHistory = (a: Axios, { count }: { count: number }) =>
  c(a, '/history').get<SearchHistory>({ params: { count } });
